import { observer } from 'src/utils/mobx-react';

import {
    OverlayDefault,
    PopupHeader,
    PopupDescription,
    AcceptBtn,
    ContentRingFencedFunds,
    LinkWrapper,
    RtpWrapper,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useAsyncButtonAction } from 'src/domains/common/hooks/useAsyncButtonAction';

interface BlockingRingfencedFundsNotificationPropsType {
    onConfirm: () => Promise<void>;
}

export const BlockingRTPNotification = observer(
    'BlockingRTPNotification',
    ({ onConfirm }: BlockingRingfencedFundsNotificationPropsType): JSX.Element | null => {
        const common = useCommon();
        const { accountHelperMail } = ConfigComponents.get(common).config;
        const { handleClick: handleConfirm, isLoading: isConfirmLoading } = useAsyncButtonAction(onConfirm);

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <ContentRingFencedFunds>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>

                    <PopupHeader>
                        <I18n
                            langKey='account.blocking-popup.rtp-notification.title'
                            defaultText='Return to Player values'
                        />
                    </PopupHeader>
                    <RtpWrapper>
                        <PopupDescription data-test='account.blocking-popup.rtp-description-line1'>
                            <I18n
                                langKey='account.blocking-popup.rtp.dear-customer'
                                defaultText='Dear Customer,'
                            />
                        </PopupDescription>
                        <PopupDescription data-test='account.blocking-popup.rtp-description-line1'>
                            <I18n
                                langKey='account.blocking-popup.rtp.description-line1'
                                defaultText='We would like to inform you of an upcoming change to the Return to Player (RTP) values across our casino games.


'
                            />
                        </PopupDescription>
                        <PopupDescription data-test='account.blocking-popup.rtp-description-line2'>
                            <I18n
                                langKey='account.blocking-popup.rtp.description-line2'
                                defaultText='

From Monday 2nd March, the RTP values across our range of casino games will be updated. Please note, gameplay will not be affected.

'
                            />
                        </PopupDescription>
                        <PopupDescription data-test='account.blocking-popup.rtp-description-line3'>
                            <I18n
                                langKey='account.blocking-popup.rtp.description-line3'
                                defaultText='All applicable RTP values can be viewed directly within each specific game. 

For further information, please access our casino pages.'
                            />
                        </PopupDescription>

                        <PopupDescription>
                            <I18n
                                langKey='account.blocking-popup.rtp.agree-mail'
                                defaultText='Please contact'
                            />{' '}
                            <LinkWrapper to={`mailto:${accountHelperMail}`}>
                                <I18n
                                    langKey='account.change-rtp-notification.email'
                                    defaultText='{accountHelperMail}'
                                    params={{ accountHelperMail }}
                                />
                            </LinkWrapper>
                            <I18n
                                langKey='account.blocking-popup.rtp.agree-mail-questions'
                                defaultText=' should you have any questions'
                            />{' '}
                        </PopupDescription>
                    </RtpWrapper>
                    <AcceptBtn
                        onClick={handleConfirm}
                        size='medium'
                        isLoading={isConfirmLoading}
                        disabled={isConfirmLoading}
                    >
                        <I18n
                            langKey='account.blocking-popup.rtp.confirm-button.label'
                            defaultText='I Acknowledge'
                        />
                    </AcceptBtn>
                </ContentRingFencedFunds>
            </OverlayDefault>
        );
    }
);
